import type { NextPage } from 'next'
import { SpacesLogin } from '@/features/spaces'

const Spaces: NextPage = () => <SpacesLogin />

export default Spaces
